module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "row outdated-row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill nav-autoix"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link",
    class: {
      'active': _vm.tabStage === 'expired'
    },
    on: {
      "click": function($event) {
        _vm.tabStage = 'expired'
      }
    }
  }, [_vm._v("過期藥物")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link",
    class: {
      'active': _vm.tabStage === 'generallyExpired'
    },
    on: {
      "click": function($event) {
        _vm.tabStage = 'generallyExpired'
      }
    }
  }, [_vm._v("即期藥物")])])]), (_vm.tabStage === 'expired') ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "drug-search-list small-drug-list"
  }, [(_vm.drugInDeviceList.length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("無過期藥物")])]) : _vm._l((_vm.drugInDeviceList), function(drug, num) {
    return _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': drug.selected
      },
      on: {
        "click": function($event) {
          return _vm.selectDrug(num)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head"
    }, [_c('div', {
      staticClass: "drug-head--content"
    }, [(drug.medication.CGMH_number !== null) ? _c('span', [_vm._v("[ " + _vm._s(drug.medication.CGMH_number) + " - "), _c('span', [_vm._v(_vm._s(drug.medication.code) + " ]")])]) : _vm._e(), _c('p', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "position"
      }
    }, [_vm._m(0, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.device.net.open_times) + " - " + _vm._s(drug.device.net.row_id) + " - " + _vm._s(drug.device.pos_row) + " - " + _vm._s(drug.device.relative_col))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "max-amount"
      }
    }, [_vm._m(1, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.stock) + "(" + _vm._s(drug.max_stock) + ")")])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "patch"
      }
    }, [_vm._m(2, true), _c('div', {
      staticClass: "info-col-content"
    }, [(drug.patch_number === '' || drug.patch_number === undefined || drug.patch_number === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(drug.patch_number))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "expired-date"
      }
    }, [_vm._m(3, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(drug.expired_date))])])])])])
  })], 2)]) : _vm._e(), (_vm.tabStage === 'generallyExpired') ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "drug-search-list small-drug-list"
  }, [(_vm.graduallyExpireDrug.length === 0) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h5', [_vm._v("無即期藥物")])]) : _vm._l((_vm.graduallyExpireDrug), function(drug, num) {
    return _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': drug.selected, 'unselectable-button': true
      }
    }, [_c('div', {
      staticClass: "drug-head"
    }, [_c('div', {
      staticClass: "drug-head--content"
    }, [(drug.medication.CGMH_number !== null) ? _c('span', [_vm._v("[ " + _vm._s(drug.medication.CGMH_number) + " - "), _c('span', [_vm._v(_vm._s(drug.medication.code) + " ]")])]) : _vm._e(), _c('p', [_vm._v(_vm._s(drug.medication.generic_name))])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "position"
      }
    }, [_vm._m(4, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.device.net.open_times) + " - " + _vm._s(drug.device.net.row_id) + " - " + _vm._s(drug.device.pos_row) + " - " + _vm._s(drug.device.relative_col))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "max-amount"
      }
    }, [_vm._m(5, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.stock) + "(" + _vm._s(drug.max_stock) + ")")])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "patch"
      }
    }, [_vm._m(6, true), _c('div', {
      staticClass: "info-col-content"
    }, [(drug.patch_number === '' || drug.patch_number === undefined || drug.patch_number === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(drug.patch_number))])])]), _c('div', {
      staticClass: "info-col",
      attrs: {
        "id": "expired-date"
      }
    }, [_vm._m(7, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(drug.expired_date))])])])])])
  })], 2)]) : _vm._e()]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.unCheckAll($event)
      }
    },
    slot: "button-8"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-7",
      "title": "全部選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkAll($event)
      }
    },
    slot: "button-7"
  }) : _vm._e(), (_vm.stage !== 'setFlowData') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始移除"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("位置(藥櫃-層-列-行)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("庫存量(最大量)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("有效期限")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("位置(藥櫃-層-列-行)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("庫存量(最大量)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("有效期限")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c39084a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RemoveOutdatedDrug.vue
// module id = 1484
// module chunks = 1